import { ExclamationCircleFilled } from "@ant-design/icons";
import { Modal, Typography } from "antd";
import { useTranslation } from "react-i18next";
import type { EmployeeCreatedResult } from "../types";

const { Paragraph, Text } = Typography;

interface TemporaryPasswordModalProps {
	result: EmployeeCreatedResult | null;
	/**
	 * Parol qaysi amaldan keyin berildi.
	 *
	 * ⚠️ Standart `"created"` — mavjud chaqiruvchi (`EmployeesPage.tsx:297`)
	 * propni bermaydi va o'zgarishsiz qoladi.
	 */
	mode?: "created" | "reset";
	onClose: () => void;
}

/**
 * Vaqtinchalik parol backend javobida FAQAT BIR MARTA keladi va hech qayerda
 * saqlanmaydi. Bu modal yopilgandan keyin uni qayta ko'rish imkoni yo'q —
 * yagona yo'l administrator tomonidan parolni qayta tiklash.
 *
 * ⚠️ **Matn `mode` ga qarab tanlanadi.** Parolni tiklashda xodim
 * YARATILMAYDI — «…uchun xodim yaratildi» matni o'sha holatda oddiy
 * yolg'on bo'lardi va administrator ro'yxatda yangi xodim izlab qolardi.
 */
export function TemporaryPasswordModal({
	result,
	mode = "created",
	onClose,
}: TemporaryPasswordModalProps) {
	const { t } = useTranslation("employees");

	return (
		<Modal
			open={result !== null}
			title={t("temporaryPasswordModal.title")}
			okText={t("temporaryPasswordModal.okText")}
			cancelButtonProps={{ style: { display: "none" } }}
			onOk={onClose}
			onCancel={onClose}
			closable={false}
			mask={{ closable: false }}
			destroyOnHidden
		>
			{result && (
				<>
					<Paragraph>
						<Text strong>{result.employee.fullName}</Text>
						{mode === "reset"
							? t("temporaryPasswordModal.resetText")
							: t("temporaryPasswordModal.createdText")}
					</Paragraph>

					<Paragraph
						copyable={{
							text: result.temporaryPassword,
							tooltips: [
								t("temporaryPasswordModal.copyLabel"),
								t("temporaryPasswordModal.copiedLabel"),
							],
						}}
						className="!mb-4 font-mono text-lg"
					>
						{result.temporaryPassword}
					</Paragraph>

					<Paragraph type="danger">
						<ExclamationCircleFilled className="mr-1" />
						{t("temporaryPasswordModal.warning")}
					</Paragraph>
				</>
			)}
		</Modal>
	);
}
